import Typography from "Components/CommonComponents/Typography";
import "./NoResultFoundSearch.css";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
const NoResultFoundSearch = ({
  children,
  primaryMessage,
  secondaryMessage,
  divClassName,
}: any) => {
  const { screen }: any = useWindowSize();
  return (
    <div
      className={
        divClassName
          ? divClassName
          : "d-flex justify-content-center align-items-center flex-column h-100"
      }
    >
      <div>{children}</div>
      <div className="d-flex align-items-center flex-column">
        <div>
          <Typography
            variant={["xxl", "xl", "lg"].includes(screen) ? "h6F" : "h6"}
            color="success"
          >
            {primaryMessage}
          </Typography>
        </div>
        <div className="noResultFoundSearchText">{secondaryMessage}</div>
      </div>
    </div>
  );
};
export default NoResultFoundSearch;
